import { css } from "@emotion/react";
import { Images } from "../../../common/images";

export const tableStyle = css`
  overflow: auto;
  .ant-table-column-title {
    font-weight: bold;
    text-align: left;
  }

  .ant-pagination-item {
    font-weight: bold;
    border: none;
    border-radius: 6px;
  }

  .ant-pagination-item-link {
    font-weight: bold;
    border: none;
  }

  .ant-pagination-item-active {
    border: 1px solid #1677ff;
  }

  .ant-select-selector {
    font-weight: bold;
    border-radius: 6px !important;
  }

  td,
  th {
    overflow: hidden;
  }
`;

export const iconStyle = css`
  height: 18px;
  margin-right: 20px;
`;

export const swatchPreviewStyle = css`
  height: 80px;
`;

export const inputSearchStyle = css`
  .ant-input-affix-wrapper {
    border-radius: 6px 0 0 6px !important;
  }

  .ant-input-search-button {
    border-radius: 0 6px 6px 0 !important;
  }
`;

export const checkboxGroupStyle = css`
  margin-left: 28px;
  > label {
    display: flex;
  }
`;

export const buttonStyle = css`
  height: 42px !important;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: #1d1d1d;
  &:active,
  &:focus {
    background: transparent;
    color: #1d1d1d;
  }

  &.active {
    background: #1677ff;
    border: #1677ff;
    color: #fff;

    > .ico-edit {
      background: url(${Images.EDIT_WHITE});
    }
  }

  &:hover {
    background: #1677ff;
    border: #1677ff;
    color: #fff;
    > .ico-eye-invisible {
      background: url(${Images.EYE_INVISIBLE_WHITE});
    }

    > .ico-eye-thumbnail {
      background: url(${Images.THUMBNAIL_WHITE});
    }

    > .ico-edit {
      background: url(${Images.EDIT_WHITE});
    }
  }

  > .ico-eye-invisible,
  > .ico-eye-thumbnail {
    width: 18px;
    height: 18px;
    display: inline-block;
  }

  > .ico-edit {
    width: 14px;
    height: 14px;
    display: inline-block;
  }

  > .ico-eye-invisible {
    background: url(${Images.EYE_INVISIBLE_BLACK});
  }

  > .ico-eye-thumbnail {
    background: url(${Images.THUMBNAIL_BLACK});
  }

  > .ico-edit {
    background: url(${Images.EDIT_BLACK});
  }
`;

export const iconSuccessStyle = css`
  background: url(${Images.CHECK_BLUE});
  width: 24px;
  height: 24px;
`;

export const notificationButonStyle = css`
  height: 28px;
  padding: 0px 8px;
  border-width: 2px;
  font-size: 14px;
  line-height: 14px;
  margin-left: 10px;

  > .ico-check-white,
  > .ico-undo {
    width: 14px;
    height: 14px;
    display: inline-block;
  }

  > .ico-check-white {
    background: url(${Images.CHECK_WHITE});
  }

  > .ico-undo {
    background: url(${Images.UNDO_BLACK});
  }
`;

export const singleTextLineStyle = css`
  width: 100%;
  margin-bottom: 0px !important;
`;

export const formInputStyle = css`
  margin-bottom: 0px !important;
`;

export const flexEndStyle = css`
  text-align: right;
`;
